import { Immutable } from "immer";
import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

export const BasketWrapper = (
    props: Immutable<{ children: React.ReactNode }>,
): React.JSX.Element => {
    // basket-wrapper is a JS hook: utils/nav-measurements.ts reads this
    // element's margin-top for the sticky-header threshold.
    return (
        <section
            className={concatClassNames([
                styles.basketWrapper,
                "basket-wrapper",
            ])}
        >
            {props.children}
        </section>
    );
};
